import { render, staticRenderFns } from "./NeedsSr22.vue?vue&type=template&id=3fe2f965&"
import script from "./NeedsSr22.vue?vue&type=script&lang=js&"
export * from "./NeedsSr22.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports